const dictionary = {
  copyright: "جميع الحقوق محفوظة.",
  cancel: "إلغاء",
  submit: "إرسال",
  reject: "رفض",
  accept: "قبول",
  "update-contact-info": "حدّث معلومات الاتصال الخاصة بك من هنا.",
  logout: "تسجيل الخروج",
  profile: "الملف الشخصي",
  delegation: "شراكة",
  agree: "أوافق",
  users: "المستخدمون",
  "user-cases": "الإعلانات",
  "connection-error": "حدثت مشكلة في الاتصال، الرجاء المحاولة لاحقاً.",
  search: "بحث",
  edit: "تعديل",
  delete: "حذف",
  user: "مواطن",
  lawyer: "محامٍ",
  admin: "مسؤول النظام (أدمن)",
  agent: "مشرف",
  premium: "مميز",
  "create-date": "تاريخ الإنشاء",
  selected: "تم الاختيار",
  approve: "وافق",
  confirm: "تأكيد",
  abort: "إلغاء",
  error: "تعذر إتمام العملية، الرجاء المحاولة لاحقاً.",
  success: "تم تنفيذ العملية بنجاح.",
  "rows-per-page": "العناصر لكل صفحة",
  active: "نشط",
  deactive: "متوقف",
  pending: "بانتظار الموافقة",
  rejected: "مرفوض",
  on_hold: "مُعلّق",
  homepage: "الصفحة الرئيسية",
  save: "حفظ",
  update_contact_info: "يرجى تحديث معلومات الاتصال قبل المتابعة.",
  review: "مراجعة",
  "my-cases": "إعلاناتي",
  "my-offers": "عروضاتي",
  "incoming-offers": "العروض المستلمة",
  "has-no-offer": "لا توجد لديك أي عروض حتى الآن.",
  "contact-us": "اتصل بنا",
  "privacy-policy": "سياسة الخصوصية",
  faq: "الأسئلة الشائعة",
  "how-to": "كيفية القيام بذلك",
  "app-require-online": "تتطلب هذه التطبيق اتصالاً بالإنترنت.",

  // Login
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  forgotPassword: "نسيت كلمة المرور",
  email: "البريد الإلكتروني",
  "email-required": "حقل البريد الإلكتروني مطلوب.",
  "email-pattern": "تنسيق البريد الإلكتروني غير صحيح، يرجى إدخال بريد صحيح.",
  password: "كلمة المرور",
  changePassword: "تحديث كلمة المرور",
  "password-required": "حقل كلمة المرور مطلوب.",
  googleLogin: "تسجيل الدخول باستخدام جوجل",
  googleRegister: "التسجيل باستخدام جوجل",
  signInWithApple: "تسجيل الدخول باستخدام أبل",
  fpSuccess: "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
  fpError: "حدث خطأ أثناء معالجة طلبك، الرجاء المحاولة لاحقًا.",
  enterCaptcha: "يرجى إدخال رمز التحقق.",
  captchaError: "يرجى إكمال التحقق الأمني (الكابتشا).",
  captchaFetchError:
    "حدث خطأ أثناء جلب رمز التحقق، يرجى المحاولة مرة أخرى لاحقًا.",
  loginError: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  userExists:
    "يوجد حساب مرتبط بهذا البريد الإلكتروني، يمكنك استخدام 'نسيت كلمة المرور'.",
  userBlocked: "تم حظر حسابك.",
  enterVerificationCode: "يرجى إدخال الرمز المرسل إلى بريدك الإلكتروني:",
  verificationFailed: "فشل التحقق.",
  registerSuccess: "تم إنشاء حسابك، يمكنك الآن تسجيل الدخول.",
  userAgreementAccept: "لقد قرأت وفهمت وأوافق على اتفاقية العضوية.",
  userNotExists:
    "لم يتم العثور على حساب بهذا البريد الإلكتروني، يرجى التسجيل أولاً.",
  userAlreadyExists:
    "يوجد حساب مرتبط بهذا البريد الإلكتروني، يمكنك استخدام 'نسيت كلمة المرور'.",
  invalidCaptcha: "رمز التحقق غير صالح، يرجى المحاولة مرة أخرى.",
  invalidEmail: "عنوان البريد الإلكتروني غير صالح، يرجى المحاولة مرة أخرى.",

  // Forgot Password
  "reset-password": "إعادة تعيين كلمة المرور",
  "new-password": "أدخل كلمة المرور الجديدة:",
  "new-password-validate": "أعد إدخال كلمة المرور الجديدة:",
  "invalid-hash": "رمز غير صالح",
  "new-password-not-valid": "يجب أن تتراوح كلمة المرور بين 6 و50 حرفًا.",
  "new-password-not-comply":
    "كلمتا المرور غير متطابقتين، يرجى إعادة الكتابة للتحقق.",
  "reset-successful":
    "تم إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول.",

  // Homepage
  "search-post": "ابحث عن إعلان...",
  "new-case": "إعلان جديد",
  "new-delegation": "شراكة جديدة",
  "open-cases": "إعلاناتك المنشورة",
  budget: "الميزانية",
  "greet-lawyer":
    'مرحبًا {0}! لا يوجد لديك أي شراكة بعد، <a href="/delegation/new">اضغط هنا</a> لإنشاء واحدة.',
  "greet-user":
    'مرحبًا {0}! لا يوجد لديك أي إعلان بعد، <a href="/case/new">اضغط هنا</a> لإنشاء واحد.',
  "are-you-lawyer":
    'هل أنت محامٍ؟ <a href="/profile">يمكنك التقديم من صفحة ملفك الشخصي هنا.</a>',
  "most-used-case-categories": "أكثر الفئات استخدامًا",
  "most-offered-cases": "الإعلانات التي حصلت على أكثر العروض",
  "most-hand-shake-cases": "الإعلانات التي تم التوصل فيها إلى اتفاق",
  "see-more-cases": "لديك {0} إعلان(ات) إضافي(ة)، انقر لرؤيتها.",
  "your-offers": "عروضك",
  "your-cases": "إعلاناتك",
  "your-partnerships": "شراكاتك",

  // Profile
  "your-profile": "معلومات ملفك الشخصي",
  "user-id": "رقم المستخدم",
  "first-name": "الاسم الأول",
  "last-name": "اسم العائلة",
  "profile-email-pattern": "الرجاء إدخال بريد إلكتروني صالح.",
  "profile-email-required": "البريد الإلكتروني مطلوب.",
  "phone-number": "رقم الهاتف",
  "profile-phone-pattern": "الرجاء إدخال رقم هاتف صالح.",
  "profile-phone-required": "رقم الهاتف مطلوب.",
  "profile-first-name-pattern": "الرجاء إدخال اسم أول صالح.",
  "profile-first-name-required": "الاسم الأول مطلوب.",
  "profile-first-name-maxLength": "يجب ألا يكون الاسم الأول طويلاً جداً.",
  "profile-last-name-pattern": "الرجاء إدخال اسم عائلة صالح.",
  "profile-last-name-required": "يجب ألا يكون اسم العائلة طويلاً جداً.",
  "user-saved": "تم حفظ معلوماتك.",
  "user-save-failed": "حدث خطأ أثناء حفظ معلوماتك، يرجى المحاولة لاحقاً.",
  "lawyer-registration-info":
    "إذا كنت مسجلاً في نقابة المحامين، يمكنك ملء هذه الحقول.",
  "lawyer-bar-info": "معلومات النقابة المعتمدة:",
  "lawyer-pending-info": "طلبك قيد المراجعة.",
  "bar-no": "رقم النقابة",
  "bar-no-minLength": "يجب أن يتكون رقم النقابة من 5 أرقام.",
  "bar-no-maxLength": "يجب أن يتكون رقم النقابة من 5 أرقام.",
  "bar-no-validate": "يجب إدخال رقم واسم النقابة معاً.",
  "bar-name": "اسم النقابة", // Eksik çeviri, Türkçe metin kullanıldı
  "bar-name-minLength": "يجب أن يتكون اسم النقابة من 10 أحرف على الأقل.",
  "bar-name-maxLength": "يجب ألا يتجاوز اسم النقابة 100 حرف.",
  "bar-name-validate": "يجب إدخال رقم واسم النقابة معاً.",
  "bar-name-pattern": "يجب أن يتكون اسم النقابة من أحرف فقط.",
  "profile-roles-validate": "رقم واسم النقابة مطلوبان لدور المحامي.",
  "enter-code": "أدخل الرمز هنا",
  "send-code": "إرسال الرمز",
  "validate-code": "تحقق من الرمز",
  "wrong-code": "رمز غير صحيح!",
  "lawyer-sign-up": "تقديم الطلب",
  "id-photos": "صور الهوية (أمامية وخلفية)",
  "id-photos-rules":
    "يرجى تحميل وجهي بطاقة عضويتك في النقابة بصيغة 'jpg'، ويجب ألا يتجاوز حجم الملف {0} ك.ب.",
  "id-photos-size-error": "يجب ألا يتجاوز حجم الملف {0} ك.ب.",
  "id-photos-missing":
    "يرجى اختيار صورتين لبطاقتك الشخصية (الوجه الأمامي والخلفي) للتقديم كمحامٍ.",
  "lawyer-application": "طلب التقديم كمحامٍ",
  "select-file": "اختر ملفاً",
  "doc-save-failed": "فشل تحميل المستند، يرجى المحاولة لاحقاً.",
  "lawyer-application-success": "تم تقديم طلبك كمحامٍ، يرجى انتظار الموافقة.",
  "lawyer-application-legal-warning":
    "<b>عضونا الكريم،</b><br/><br/> من خلال التسجيل هنا، تطلب إضافتك إلى النظام كمحامٍ. من خلال هذا الطلب، تصرح بأنك محامٍ مسجل لدى اتحاد نقابات المحامين في تركيا. سيتم طلب وثائق هويتك أيضاً. إذا تم استيفاء جميع الشروط، فسيتم تحديث ملفك كمحامٍ بدلاً من مواطن. تتحمل أنت المسؤولية القانونية والجنائية الكاملة عن صحة المعلومات المقدمة.<br/><br/> بإكمال تقديمك، فإنك تقر وتوافق مسبقاً على ذلك.",
  lawyerAgreementAccept: "أوافق على الالتزامات والمسؤوليات المذكورة أعلاه.",
  "deactivate-user": "إزالة الحساب",
  "deactivate-user-info": `
    عند إزالة حسابك، سيتم إيقاف جميع إعلاناتك وسيتم إغلاق عروضك.
    لن يتمكن المستخدمون الآخرون من رؤية إعلاناتك وعروضك.
    عند رغبتك في تسجيل الدخول، ستحتاج إلى التسجيل مرة أخرى باستخدام عنوان البريد الإلكتروني المرتبط بحسابك.
    <br/><br/>
    هل أنت متأكد أنك تريد إزالة حسابك؟
  `,
  "user-deactivated": "تم إزالة حسابك.",
  "user-deactivate-failed": "فشل إزالة الحساب، يرجى المحاولة لاحقاً.",

  // Notifications
  notifications: "الإشعارات",
  new_offer_title: "لديك عرض جديد",
  new_offer_description: "تلقيت عرضاً للإعلان رقم {0}.",
  "mark-as-read": "تعليم كمقروء",
  offer_accepted_title: "تم قبول عرضك",
  offer_accepted_description:
    "تم قبول عرضك للإعلان رقم {0} من قبل صاحب الإعلان. يمكنك الوصول إلى معلومات الاتصال من قسم العروض.",
  offer_rejected_title: "تم رفض عرضك",
  offer_rejected_description:
    "تم رفض عرضك للإعلان رقم {0} من قبل صاحب الإعلان. يمكنك مراجعة سبب الرفض في ملفك الشخصي.",
  offer_published_title: "تم إرسال عرضك",
  offer_published_description:
    "تم إرسال عرضك للإعلان رقم {0} بنجاح. يمكنك الآن انتظار رد من صاحب الإعلان.",
  case_approved_title: "تم اعتماد إعلانك",
  case_approved_description:
    "تم نشر إعلانك رقم {0}، يمكن للمحامين المسجلين رؤيته وتقديم عروض.",
  case_rejected_title: "تم رفض إعلانك",
  case_rejected_description:
    "تم رفض إعلانك رقم {0}، يمكنك مراجعة سبب الرفض في ملفك الشخصي.",
  lawyer_application_approved_title: "تم قبول طلبك كمحامٍ",
  lawyer_application_approved_description:
    "تهانينا، يمكنك الآن رؤية الإعلانات وتقديم العروض.",
  lawyer_application_rejected_title: "تم رفض طلبك كمحامٍ",
  lawyer_application_rejected_description:
    "نأسف، لكن يجب أن تستوفي الشروط التالية لتصبح محامياً: {2}",

  // Cases
  "pending-cases": "الإعلانات قيد الانتظار",
  "rejected-cases": "الإعلانات المرفوضة",
  "inactive-cases": "الإعلانات غير النشطة",
  "on-hold-cases": "الإعلانات المؤجلة",
  "more-case-with-premium":
    "حد نشر الإعلانات لحسابك هو {0}، يمكنك الترقية إلى حساب بريميوم لنشر المزيد.",
  "your-case-limit": "لديك ما مجموعه {0} حقاً لنشر الإعلانات.",

  // CaseItem Details
  case: "الإعلان",
  "case-code": "رمز الإعلان",
  "missing-case-id-in-url":
    "لم يتم التمكن من الوصول إلى معلومات الإعلان، رقم الإعلان مفقود في العنوان.",
  "case-category-selection": "الموضوع",
  "please-select-main-category": "الرجاء اختيار نوع الخدمة",
  "please-select-sub-category": "الرجاء اختيار موضوع الخدمة",
  "main-category-info": `عزيزنا المستخدم، وفقًا لقوانيننا، يمكن للمحامين متابعة جميع القضايا القانونية. ومع ذلك، لديهم الحق في اختيار القضايا التي يرغبون في متابعتها. من الملاحظ أن العديد من المحامين يتخصصون في مجالات معينة. لهذا السبب، فإن اختيار موضوع القضية بشكل صحيح يساعدك في الوصول بشكل أسرع إلى المحامين المتخصصين. لقد قمنا بتقسيم المواضيع إلى ثلاثة فروع رئيسية: الجنائية، المدنية، وغيرها، وكل فرع يحتوي على تصنيفات فرعية لتسهيل الاختيار. يرجى اختيارك بعناية. سيقوم مشرفونا المتخصصون بمراجعة تفضيلاتك. وسيتم تعديل أو إزالة الإعلانات غير الدقيقة أو غير المقبولة.`,
  back: "رجوع",
  next: "التالي",
  "case-city-selection": "الموقع",
  "please-select-case-city": "محافظة القضية",
  "please-select-user-city": "محافظتك",
  "case-description": "الوصف",
  "please-enter-short-desc": "الرجاء إدخال وصف مختصر لمشكلتك",
  "please-enter-long-desc": "هل ترغب في تقديم معلومات مفصلة؟",
  "please-write-here": "اكتب هنا...",
  "please-write-category": "اكتب عنوان الموضوع الذي تبحث عنه...",
  summary: "الملخص",
  "please-review-case-details": "المعلومات المدخلة",
  "case-type": "التصنيف الرئيسي للقضية",
  "case-sub-type": "التصنيف الفرعي للقضية",
  "case-city": "مدينة القضية (المحكمة)",
  "user-city": "مدينة المدعي",
  "case-short-desc": "وصف مختصر",
  "case-long-desc": "وصف تفصيلي",
  "upgrade-to-premium": "الترقية إلى بريميوم الآن",
  "short-desc-required": "الرجاء إدخال وصف مختصر لا يقل عن 50 حرفًا",
  "short-desc-minLength": "استمر في الكتابة حتى تصل إلى 50 حرفًا على الأقل",
  "short-desc-maxLength": "يمكنك إدخال حتى 500 حرف كحد أقصى",
  "budget-required": "الرجاء إدخال سعر",
  "budget-min": "يجب أن يكون الرقم المدخل على الأقل 100",
  "give-offer": "تقديم عرض",
  "lawyer-offer-text": "الرجاء إدخال شرح لا يقل عن 50 حرفًا للموكل المحتمل...",
  "min-offer-price-error": "الحد الأدنى الذي يمكنك إدخاله هو: {0}",
  "empty-offer-description-error": "الرجاء كتابة وصف مختصر",
  "lawyer-description-legal-warning-header":
    "الرجاء قراءة النص التالي والموافقة عليه:",
  "lawyer-description-legal-warning": `عزيزنا المستخدم المحامي؛ يمكنك تعزيز عرضك من خلال تقديم نفسك بشكل مختصر في قسم التوضيح. لن يتم قبول العروض التي تتضمن توجيهات قانونية أو تنتهك اتفاقية العضوية أو القوانين. من خلال النقر على زر الإرسال، فإنك تقر بتحملك المسؤولية القانونية والجزائية الكاملة عن محتوى عرضك في حال مخالفته لأي من الشروط.`,
  "type-more-with-premium":
    "قم بالترقية إلى بريميوم لاستخدام عدد أكبر من الأحرف",
  "max-char-reached": "لقد وصلت إلى الحد الأقصى لعدد الأحرف",
  "more-offers-with-premium":
    "لقد استخدمت {0}/{1} من حقوق تقديم العروض، قم بالترقية للحصول على عدد غير محدود!",
  "see-offers": "عرض العروض ({0})",
  "contact-choice": "تفضيل التواصل",
  contact: "تواصل",
  "case-saved":
    "تم استلام طلب الإعلان الخاص بك وسيتم نشره بعد الفحوصات اللازمة.",
  "please-select-one-contact-choice": "الرجاء اختيار خيار واحد على الأقل",
  EMAIL: "البريد الإلكتروني",
  PHONE: "الهاتف",
  IN_PERSON: "بشكل شخصي",
  "change-short-desc": "يمكنك تعديل الوصف من هنا:",
  "low-budget": "منخفض (₺)",
  "mid-budget": "متوسط (₺₺)",
  "high-budget": "مرتفع (₺₺₺)",
  "unset-budget": "لا أرغب في التحديد",
  kvkk: `أُقر وأقبل وأتعهد بما يلي:<br/><br/>• أن هذا الإعلان ومحتواه متوافق مع “اتفاقية عضوية Vekilet” التي قمت بالموافقة عليها أثناء تقديم طلب العضوية وجميع القوانين واللوائح ذات الصلة.<br/><br/>• أوافق على نشر المعلومات التي قدمتها ضمن نطاق الإعلان على الموقع بموافقتي.<br/><br/>• أتحمل المسؤولية القانونية والجزائية الكاملة عن أي محتوى ضمن هذا الإعلان.<br/><br/>• مالك هذا الموقع لا يتحمل أي مسؤولية عن النص الذي قمت بكتابته شخصيًا.<br/><br/>بموافقتي على هذا النص أُقر وأعلن وأتعهد بكل ما سبق.`,
  "description-info": `عزيزنا المستخدم؛ نرجو تقديم معلومات موجزة توضح نزاعك القانوني. نرجو عدم مشاركة أي معلومات قد تشكل جريمة أو تضر بقضيتك مستقبلاً.<br/><br/>يرجى الكتابة بشكل واضح ومفهوم وموجز.<br/><br/>مثال:<br/>"المستأجر الذي يسكن في العقار الذي استأجرته في مايو 2019 لم يدفع الإيجار منذ 6 أشهر. أود الحصول على دعم من محامٍ متخصص في هذا الشأن."<br/><br/>يمكنك مناقشة التفاصيل مع المحامين الذين سيتواصلون معك.<br/>سيتم مراجعة تفضيلاتك والتحقق منها من قبل الخبراء. سيتم تعديل أو إزالة الإعلانات غير المناسبة أو غير المكتملة.`,
  "budget-info":
    "عزيزنا المستخدم؛ من خلال تحديد الميزانية التي يمكنك تخصيصها للدعم القانوني، يمكنك الوصول إلى محامٍ مناسب بشكل أسرع",
  "contact-info":
    "عزيزنا المستخدم؛ في هذا القسم يمكنك تحديد تفضيلات التواصل لتوضيح من أي قنوات تريد للمحامين الذين قبلت عروضهم أن يتواصلوا معك",
  "deactivation-warning":
    "عند إيقاف إعلانك، ستفقد جميع العروض المقدمة له. هل لا تزال ترغب بالمتابعة؟",

  // Delegation Details
  city: "المدينة",
  district: "المنطقة",
  "please-select-city": "الرجاء اختيار مدينة",
  "please-select-district": "الرجاء اختيار منطقة",
  "please-enter-short-desc-lawyer": "الرجاء إدخال وصف لزملائك المحامين",
  delegationAgreement: `عزيزي المستخدم المحامي؛ يمكنك نشر إعلان من أجل تنفيذ أعمالك، التي لديك فيها توكيل، مع زملائك الآخرين، مع طلب "إعلان الشراكة". نود أن نذكرك بمبادئ المسؤولية المهنية المتعلقة بإعلانات الشراكة، وتقبل وتعلن أنك ملزم بضمان أن الإعلانات التي ستقوم بها تتوافق مع قانون المحاماة وكذلك الدستور وجميع القوانين واللوائح، وأنه في حالة الانتهاك، ستكون جميع المسؤوليات القانونية والجنائية عليك بعد إرسال طلب نشر هذا الإعلان.`,

  // CaseItem Search
  "no-search-result":
    "لم يتم العثور على نتائج مطابقة لمعايير البحث، يرجى المحاولة بكلمات مختلفة.",
  "order-by": "ترتيب حسب",
  "filter-by": "تصفية حسب",
  budgetAsc: "الميزانية ↑",
  budgetDesc: "الميزانية ↓",
  createDateAsc: "تاريخ الإنشاء ↑",
  createDateDesc: "تاريخ الإنشاء ↓",
  userProvinceAsc: "المدينة ↑",
  userProvinceDesc: "المدينة ↓",
  caseTypeAsc: "نوع القضية ↑",
  caseTypeDesc: "نوع القضية ↓",

  // Lawyer Summary
  "citizen-cases": "إعلانات المواطنين",
  "lawyer-cases": "إعلانات الشراكة",
  "see-more-cases-lawyer": "عرض المزيد من الإعلانات...",
  "lawyer-offer-info": "الرجاء اختيار نطاق سعري لعرضك على الموكل",
  "open-offers": "عروضك المعلقة",
  "new-offer": "لديك عرض لم يتم نشره بعد",
  "approved-offers": "عروضك المقبولة",
  "rejected-offers": "عروضك المرفوضة",
  "on-hold-offers": "عروضك المؤجلة",
  "see-more-offers": "اضغط هنا لمشاهدة عروضك الأخرى",

  // OfferItem
  "offer-for-this-case": "أنت تقيّم العرض لهذا الإعلان",
  "lawyer-message": "رسالة المحامي",
  offers: "العروض",
  "no-offer-for-case": "لا توجد عروض حتى الآن لهذا الإعلان",
  "phone-required-to-accept-offer":
    "يجب أن يكون لديك رقم هاتف مسجل في النظام لقبول العروض",
  "you-rejected-offer": "لقد رفضت العرض",
  "offer-on-hold": "تم تعليق هذا العرض لأنك بدأت اتفاقاً مع عرض آخر",
  "start-agreement": "بدء الاتفاق",
  "started-agreement":
    "لقد بدأت اتفاقاً لهذا العرض، وتمت مشاركة معلومات الاتصال الخاصة بك مع المحامي. يمكنك إلغاء الاتفاق خلال أسبوعين أو سيتم إنهاء الإعلان تلقائياً.",
  "abort-agreement": "إلغاء الاتفاق",
  "bar-number": "رقم النقابة",
  "no-client-action": "الموكل لم يقيم أي عرض بعد",
  "your-offer": "عرضك",
  "your-offer-sent": "تم إرسال عرضك",
  "your-offer-rejected": "تم رفض عرضك",
  "client-on-hold-offer":
    "تم تعليق هذا العرض لأن الموكل بدأ اتفاقاً مع عرض آخر. إذا أُلغي الاتفاق، فسيُعاد النظر في عرضك.",
  "client-reject-offer": "الموكل رفض عرضك",
  "client-accepted-offer": "الموكل قبل عرضك",
  "client-preferred-contact": "معلومات الاتصال المفضلة للموكل",
  "client-information": "معلومات الموكل",
  "confirm-offer-approve":
    "تنبيه: بعد قبول العرض، سيتم مشاركة معلومات الاتصال الخاصة بك مع مقدم العرض، ولن تتمكن من إلغاء العرض لمدة يومين. هل تؤكد؟",
  user_approved_other_offer: "مالك الإعلان يقوم بتقييم عرض آخر",

  // Admin
  documents: "المستندات",
  "please-type-keyword": "الرجاء إدخال كلمة مفتاحية في حقل البحث",
  "no-result": "لم يتم العثور على نتائج",
  "admin-panel": "لوحة إدارة وكيلت",
  "approval-pending-cases": "الإعلانات بانتظار الموافقة",
  "select-cases-to-process": "يمكنك اختيار الإعلانات التي تريد معالجتها",
  "case-owner": "مالك الإعلان",
  "approve-selected-cases": "هل أنت متأكد أنك تريد الموافقة على هذه الإعلانات؟",
  "reject-selected-cases": "الرجاء توضيح سبب الرفض باختصار",
  "reject-reason": "سبب الرفض",
  "reject-reason-minlength": "الرجاء إدخال 10 أحرف على الأقل",
  "reject-reason-maxlength": "لا تدخل أكثر من 100 حرف",
  block: "حظر",
  unblock: "إزالة الحظر",
  activate: "نشر",
  deactivate: "إيقاف",
  "activate-user": "Activate",
  "approval-pending-lawyers": "طلبات المحامين بانتظار الموافقة",
  "user-roles": "أدوار المستخدم",

  // Premium
  subscribePremiumNow: "قم بالترقية إلى الحساب المميز الآن",
  premiumPageTitle: "انتقل الآن إلى الحساب المميز!",
  premiumPageSubtitle:
    "عزيزي المحامي؛ يمكنك من خلال دفع مبلغ رمزي الترقية إلى حساب مميز وتقديم عدد غير محدود من العروض والوصول إلى المزيد من المواطنين.",
  creditCardInformation: "معلومات بطاقة الائتمان",
  cardHolderName: "اسم صاحب البطاقة",
  cardNumber: "رقم البطاقة",
  expirationMonth: "الشهر",
  expirationYear: "السنة",
  cvv: "رمز الأمان (CVV)",
  "card-holder-required": "هذا الحقل مطلوب",
  "card-holder-minLength": "الرجاء إدخال 6 أحرف على الأقل",
  "card-holder-maxLength": "يمكنك إدخال حتى 60 حرفاً",
  "card-holder-pattern": "الرجاء إدخال أحرف فقط",
  "card-number-required": "هذا الحقل مطلوب",
  "card-number-minLength": "الرجاء إدخال رقم بطاقة مكون من 16 رقمًا",
  "card-number-maxLength": "يجب أن يكون رقم البطاقة 16 رقمًا",
  "card-number-pattern": "الرجاء إدخال أرقام فقط",
  "expiration-month-required": "هذا الحقل مطلوب",
  "expiration-month-minLength": "الرجاء إدخال شهر مكون من رقمين",
  "expiration-month-maxLength": "يجب أن يكون الشهر رقمين",
  "expiration-month-pattern": "الرجاء إدخال أرقام فقط",
  "expiration-month-max": "يجب ألا يتجاوز الشهر 12",
  "expiration-month-min": "يجب أن يكون الشهر 01 على الأقل",
  "expiration-year-required": "هذا الحقل مطلوب",
  "expiration-year-minLength": "الرجاء إدخال سنة مكونة من 4 أرقام",
  "expiration-year-maxLength": "يجب أن تكون السنة 4 أرقام",
  "expiration-year-pattern": "الرجاء إدخال أرقام فقط",
  "cvv-required": "هذا الحقل مطلوب",
  "cvv-minLength": "الرجاء إدخال رمز CVV المكون من 3 أرقام على ظهر البطاقة",
  "cvv-maxLength": "يجب أن يكون رمز CVV 3 أرقام",
  "cvv-pattern": "الرجاء إدخال أرقام فقط",
  "make-payment": "إجراء الدفع",

  // CaseItem Categories
  "c-1": "القضايا الجنائية",
  "c-2": "قضايا القانون الخاص والعام",
  "c-3": "متابعات أخرى ومعاملات أجنبية",
  "c-1-b-1": "محكمة الجنايات الابتدائية",
  "c-1-b-2": "محكمة الجنايات الكبرى",
  "c-1-b-3": "تحقيقات النيابة",
  "c-2-b-1": "قانون الأسرة",
  "c-2-b-2": "القانون التجاري",
  "c-2-b-3": "محكمة الصلح المدني",
  "c-2-b-4": "محكمة الكاداستر",
  "c-2-b-5": "محكمة المستهلك",
  "c-2-b-6": "محكمة العمل",
  "c-2-b-7": "محكمة المدني الابتدائية",
  "c-2-b-8": "محكمة الملكية الفكرية",
  "c-2-b-9": "أخرى",
  "c-2-b-10": "الدعاوى الإدارية",
  "c-3-b-1": "إجراءات المواطنين الأجانب",
  "c-3-b-2": "الاستشارات",
  "c-3-b-3": "التنفيذ",
  "c-1-b-1-s-1": "جريمة السرقة",
  "c-1-b-1-s-2": "الجرائم الجنسية",
  "c-1-b-1-s-3": "جريمة الإهانة",
  "c-1-b-1-s-4": "جريمة التهديد",
  "c-1-b-1-s-5": "جريمة الإصابة",
  "c-1-b-1-s-6": "الإضرار بالممتلكات",
  "c-1-b-1-s-7": "جريمة الاحتيال",
  "c-1-b-1-s-8": "إساءة استخدام الثقة",
  "c-1-b-1-s-9": "تعاطي/حيازة المخدرات",
  "c-1-b-1-s-10": "التزوير",
  "c-1-b-1-s-11": "جرائم الحاسوب",
  "c-1-b-1-s-12": "أخرى",
  "c-1-b-2-s-1": "تجارة المخدرات",
  "c-1-b-2-s-2": "الجرائم المنظمة",
  "c-1-b-2-s-3": "التزوير",
  "c-1-b-2-s-4": "الجرائم الجنسية",
  "c-1-b-2-s-5": "السرقة بالإكراه",
  "c-1-b-2-s-6": "التهريب",
  "c-1-b-2-s-7": "القتل",
  "c-1-b-2-s-8": "أخرى",
  "c-1-b-3-s-1": "المتهم قيد الاحتجاز",
  "c-1-b-3-s-2": "المتهم ليس قيد الاحتجاز",
  "c-1-b-3-s-3": "تقديم شكوى",
  "c-2-b-1-s-1": "قضايا الإرث",
  "c-2-b-1-s-2": "قضايا الطلاق",
  "c-2-b-1-s-3": "تعيين وصي / قيّم",
  "c-2-b-1-s-4": "قضايا النفقة",
  "c-2-b-1-s-5": "قضايا الحضانة",
  "c-2-b-1-s-6": "أوامر التقييد والتدابير",
  "c-2-b-1-s-7": "أخرى",
  "c-2-b-2-s-1": "قضايا التحصيل",
  "c-2-b-2-s-2": "أخرى",
  "c-2-b-3-s-1": "قضايا الإيجار",
  "c-2-b-3-s-2": "قضايا إدارة المواقع/الشقق",
  "c-2-b-3-s-3": "قضايا تصفية الشراكة",
  "c-2-b-3-s-4": "أخرى",
  "c-2-b-4-s-1": "محكمة الكاداستر",
  "c-2-b-5-s-1": "التحصيل",
  "c-2-b-5-s-2": "التعويض",
  "c-2-b-5-s-3": "طلب هيئة التحكيم",
  "c-2-b-5-s-4": "أخرى",
  "c-2-b-6-s-1": "مطالبات العمال",
  "c-2-b-6-s-2": "التعويض",
  "c-2-b-6-s-3": "إعادة التوظيف",
  "c-2-b-6-s-4": "أخرى",
  "c-2-b-7-s-1": "المنازعات العقارية",
  "c-2-b-7-s-2": "التحصيل",
  "c-2-b-7-s-3": "أخرى",
  "c-2-b-8-s-1": "دعاوى العلامات التجارية وبراءات الاختراع",
  "c-2-b-9-s-1": "أخرى",
  "c-2-b-10-s-1": "دعاوى إلغاء القرارات الإدارية",
  "c-2-b-10-s-2": "دعاوى التعويض الإداري",
  "c-2-b-10-s-3": "أخرى",
  "c-2-b-10-s-4": "دعاوى الضرائب",
  "c-3-b-1-s-1": "إجراءات الجنسية",
  "c-3-b-1-s-2": "إجراءات تصريح الإقامة",
  "c-3-b-1-s-3": "إجراءات تصريح العمل",
  "c-3-b-1-s-4": "إجراءات الاعتراض على الترحيل",
  "c-3-b-1-s-5": "إجراءات التأشيرة",
  "c-3-b-1-s-6": "إجراءات الاستشارات",
  "c-3-b-1-s-7": "أخرى",
  "c-3-b-2-s-1": "الاستشارات الشفوية (قائمة على الاجتماعات)",
  "c-3-b-2-s-2": "الاستشارات المكتوبة (لتحضير الوثائق)",
  "c-3-b-2-s-3": "التمثيل في الوساطة",
  "c-3-b-2-s-4": "أخرى",
  "c-3-b-3-s-1": "تمثيل الدائنين",
  "c-3-b-3-s-2": "تمثيل المدينين",
  "c-3-b-3-s-3": "أخرى",
};

export default dictionary;
